<template>
  <div>
    <div class="i-layout-page-header">
      <div class="i-layout-page-header">
        <Button icon="ios-arrow-back" size="small" class="mr20" @click="$router.go(-1)">返回</Button>
        <span class="ivu-page-header-title mr20" v-text="$route.meta.title"></span>
      </div>
    </div>
    <Card :bordered="false" dis-hover class="ivu-mt">
      <Form ref="infoData" :model='infoData' label-position="right" :label-width="200"
            @submit.native.prevent>

        <Row :gutter="24" type="flex">

          <Col span="24">
            <FormItem label="包装批次信息" prop="packing_id">
              <div style="width: 50%;min-width: 500px;padding: 10px;border-radius: 10px;border: 1px solid #ccc">

                <Row type="flex" justify="space-around" align="middle" style="margin-bottom: 20px;">

                  <Col span="12">
                    所属基地: {{packingData.land_base_name}}
                  </Col>
                  <Col span="12">
                    所属地块: {{packingData.land_sn}}
                  </Col>

                </Row>
                <Row type="flex" justify="space-around" align="middle" style="margin: 20px 0;">

                  <Col span="12">
                    包装批次号: {{packingData.packing_sn}}
                  </Col>
                  <Col span="12">
                    包装数量(kg): {{packingData.weight}}
                  </Col>

                </Row>

                <Row type="flex" justify="space-around" align="middle" style="margin: 20px 0;">

                  <Col span="12">
                    包装材料: {{packingData.material}}
                  </Col>
                  <Col span="12">
                    包装形式: {{packingData.packing_type}}
                  </Col>

                </Row>

                <Row type="flex" justify="space-around" align="middle" >

                  <Col span="12">
                    包装日期: {{packingData.date}}
                  </Col>
                  <Col span="12">
                    备注: {{packingData.remark}}
                  </Col>

                </Row>

              </div>

            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="认证类型" prop="certification_type_id">
              <Input disabled="disabled" class="perW30" v-model="infoData.certification_type_name"></Input>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="证书编号" prop="certificate_number">
              <Input disabled="disabled" class="perW60" v-model="infoData.certificate_number"></Input>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="认证证书" prop="certificate_images">
              <img v-for="(item,key) in infoData.certificate_images" :src="item" style="width: 50px;height: 50px;margin-right: 4px;" alt="认证证书" @click="showImage(item)">
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="认证时间" prop="certification_date">
              <DatePicker type="date" disabled="disabled" v-model="infoData.certification_date" class="perW30"></DatePicker>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="认证机构" prop="certifying_agency">
              <Input disabled="disabled" class="perW60" v-model="infoData.certifying_agency"></Input>
            </FormItem>
          </Col>

        </Row>

      </Form>
    </card>

  </div>
</template>
<script>
import {qualityCertificationsInfoApi} from '@/api/processing/quality/qualityCertifications'
import {plantProductionPackingInfoApi} from "@/api/processing/processing/plantProductionPacking";
import {showImageModal} from "_c/common/showImageModal";

export default {
  name: 'qualityCertificationsInfo',
  components: {},
  data() {
    return {
      infoData: {
        inspection_id: 0,
        packing_id: 0,
        certification_type_name: '',
        certificate_number: '',
        certificate_images: [],
        certification_date: '',
        certifying_agency: '',
      },
      packingData: {
        id: 0,
        land_base_name: '',
        land_sn: '',
        packing_sn: '',
        weight: '',
        material: '',
        packing_type: '',
        date: '',
        remark: '',
      },
    }
  },
  mounted() {
    if (this.$route.params.id !== '0' && this.$route.params.id) {
      this.loadInfoData(this.$route.params.id)
    }
  },
  methods: {

    // 加载数据
    loadInfoData(id) {
      qualityCertificationsInfoApi(id).then(res => {
        //数据赋值
        this.infoData = res.data

        // 查询包装批次
        this.loadPackingData(this.infoData.packing_id)

      }).catch(res => {
        this.$Message.error(res.msg)
      })
    },

    // 加载包装信息
    loadPackingData(id) {
      plantProductionPackingInfoApi(id).then(res => {
        //数据赋值
        this.packingData = res.data

      }).catch(res => {
        this.$Message.error(res.msg)
      })
    },

    // 图片放大
    showImage(url){
      showImageModal(url)
    }

  }
}
</script>
